import { createFileRoute } from '@tanstack/react-router';

import { SupplierOrdersPage } from '@/features/supplier/orders-page';

export const Route = createFileRoute('/_app/supplier/$orgId/orders/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierOrdersPage {...params} />;
}
